(function(root){
  'use strict';
  const CAP_RATIO=.34;
  function overlay(font,geometry,line){
    const {center,halfWidth,y,height,maxWidth}=geometry;
    const capHeight=height*CAP_RATIO;
    const width=[...line].reduce((sum,ch)=>sum+(font.glyphs[ch]?.w||0),0);
    const scale=Math.min(capHeight/1472,maxWidth/Math.max(1,width));
    const actualCap=1472*scale;
    const a=(y[0]+y[2]-2*y[1])/(2*halfWidth*halfWidth),b=(y[2]-y[0])/(2*halfWidth);
    let offset=-width*scale/2;
    return [...line].map(ch=>{
      const glyph=font.glyphs[ch];if(!glyph)throw Error('Caractère non pris en charge');
      const advance=glyph.w*scale,x=center+offset+advance/2,dx=x-center;
      const angle=Math.atan(2*a*dx+b),cy=a*dx*dx+b*dx+y[1];
      const tx=x-Math.sin(angle)*actualCap/2,ty=cy+Math.cos(angle)*actualCap/2;
      offset+=advance;
      return `<g transform="translate(${tx} ${ty}) rotate(${angle*180/Math.PI})"><path d="${glyph.d}" transform="translate(${-advance/2} 0) scale(${scale} ${-scale})"/></g>`;
    }).join('');
  }
  root.TourismoLettering={overlay,CAP_RATIO};
  if(typeof module!=='undefined')module.exports={overlay,CAP_RATIO};
})(typeof window==='undefined'?globalThis:window);
